export const SET_EDIT_ROLE_REPORTS_LOADED = "SET_EDIT_ROLE_REPORTS_LOADED";

export const setEditRoleReportsLoaded = (editRoleReportsLoaded: boolean) => {
  return {
    editRoleReportsLoaded,
    type: SET_EDIT_ROLE_REPORTS_LOADED
  };
};
